module.exports = __webpack_public_path__ + "989d4b97253ca33623e33ac8204de786.svg";